import React, { Component } from 'react';
import CartFormWithValidation from './cart-components/cart-form';
import Header from './header';
import Footer from './footer';
import store from 'store';
import superagent from 'superagent';
import './cart.css';
import { withTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { getUrlQuery, getPublicUrl } from '../utils/utils';
import i18n from 'i18next';
import axios from 'axios';
import queryString from 'query-string';
import shippingApi from '../api/shipping-api';

class Cart extends Component {
  constructor(props) {
    super(props);

    this.api = axios.create({
      baseURL: '/api',
    });

    this._liqpayForm = React.createRef();
    this._wayForPayForm = React.createRef();

    this.isTestActive = false;
    const queryParams = queryString.parse(props.location.search);
    if (queryParams) {
      if (queryParams.test) {
        this.isTestActive = true;
      }
    }

    var d = new Date();
    this.orderId = this.randomIntFromInterval(1000, 9999);
    this.wayForPayId =
      d.getFullYear().toString().substr(-2) +
      '_' +
      `0${d.getMonth() + 1}`.slice(-2) +
      '_' +
      `0${d.getDate()}`.slice(-2) +
      '_' +
      this.orderId;

    var url = '';
    try {
      url = window.location.protocol + '//' + window.location.host;
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
    this.redirectUrl = url + getPublicUrl(i18n) + '/completed/' + this.orderId;
    this.serverUrl = url + '/api/wayforpay/confirm';

    this.product = store.get('product');

    if (!this.product) {
      this.product = {
        description: {},
      };
    }

    const { productType, material, hanger, price, size } = this.product;

    this.product.note = '';
    if (productType && productType === 'sky') {
      if (this.product.text2 != this.product.text2BeforeManualEdit) {
        this.product.note += 'Текст2 был изменён клиентом вручную. ';
        //Если изменилась дата в тексте, то надо будет вручную изменить и дату в звёдном небе.
      }
    }

    if (!this.areTextsInSameLanguage(this.product.text1, this.product.text2)) {
      this.product.note += 'Текст1 и Текст2 используют разные языки. ';
    }

    if (productType && productType === 'audio') {
      this.productName = `Плакат Аудіохвиля ${size}`;
      this.pixelId = '832974670888918';
      this.gTagId = 'UA-119404542-5';
    } else {
      this.productName = `Плакат Зоряне небо ${size}`;
      this.pixelId = '532340200777420';
      this.gTagId = 'UA-119404542-2';
    }

    this.canShipFromFactory = false;
    if (
      material === 'Холст' ||
      (material === 'Бумага' && hanger === 'Нет') ||
      (material === 'ПВХ' && (hanger === 'Нет' || hanger === 'Лента'))
    ) {
      this.canShipFromFactory = true;
    }

    this.canPayByCash = false;
    if (size === '70х100 см' && !(material === 'Бумага' && hanger === 'Нет')) {
      this.canPayByCash = false;
    }

    this.canShipFromByVlad = true;
    if (hanger === 'Рамка' && (size === '40х50 см' || size === '50х70 см')) {
      this.canShipFromByVlad = false;
    }

    this.isFreeShippingTurnedOn = false;
    this.needPrepayment = false;
    if (price > 1500) {
      this.needPrepayment = true;
    }

    this.state = {
      redirect: null,
      isSubmitting: false,
      basePrice: price,
      priceWithoutShipping: price,
      promocode: '',
      succeededPromocode: '',
      isPromocodeFailed: false,
      shippingCost: null,
      price: price,
      buttonData: '',
      buttonSignature: '',
      wayForPay: {},
      isWayForPayEnabled: false,
      shippingDates: null,
    };

    if (this.product.map) {
      this.product.map.language = this.fixMapLanguage(
        this.product.map.language,
        this.product.text1,
        this.product.text2
      );
    }

    console.log('getUrlQuery');
    window.getUrlQuery = () => {
      const {
        date,
        printWidth,
        printHeight,
        style,
        place: { centerLat, centerLon },
        map: {
          mapWidth,
          mapHeight,
          containerWidth,
          containerHeight,
          background,
          stroke,
          isGridEnabled,
          isConstellationsEnabled,
          isMWEnabled,
          isNamesEnabled,
          language,
        },
      } = this.product;

      var obj = {
        date,
        printWidth,
        printHeight,
        style,
        centerLat,
        centerLon,
        mapWidth,
        mapHeight,
        containerWidth,
        containerHeight,
        background,
        stroke,
        isGridEnabled,
        isConstellationsEnabled,
        isMWEnabled,
        isNamesEnabled,
        language,
      };
      const query = getUrlQuery(obj);

      console.log(query);
    };
  }

  componentDidMount() {
    try {
      const host = window.location.hostname;
      if (host.indexOf('localhost') !== 0) {
        window.gtag('event', 'cart', {
          send_to: this.gTagId,
          event_category: 'main',
        });

        window.fbq('trackSingle', this.pixelId, 'AddToCart');
      }
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }

    if (this.state.isWayForPayEnabled) {
      this.updateWayForPayFormParameters(
        this.wayForPayId,
        this.state.price,
        this.productName
      );
    }

    try {
      shippingApi
        .getShippingDates(this.canShipFromFactory)
        .then((r) => {
          this.setState({
            shippingDates: r,
          });
        })
        .catch((e) => {
          this.setState({
            shippingDates: null,
          });
          (console.error || console.log).call(console, e.stack || e);
        });
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    //if (prevState.price !== this.state.price && this.isTestActive) {
    if (
      prevState.price !== this.state.price
      //&& (!isNaN(prevState.price) || !isNaN(this.state.price))
    ) {
      //this.setState({ price: 50 });
      if (this.state.isWayForPayEnabled) {
        this.updateWayForPayFormParameters(
          this.wayForPayId,
          this.state.price,
          this.productName
        );
      }
    }
  }

  getPrice(priceWithoutShipping, shippingCost) {
    if (priceWithoutShipping == null) return undefined;
    if (shippingCost == null) return priceWithoutShipping;
    return priceWithoutShipping + shippingCost;
  }

  updateWayForPayFormParameters(wayForPayId, sum, productName) {
    this.setState({ isLoading: true, wayForPay: {} });
    this.getWayForPayFormParameters(wayForPayId, sum, productName)
      .then((res) => {
        console.log('received wayForPay form parameters', res);
        this.setState({
          isLoading: false,
          wayForPay: {
            returnUrl: this.redirectUrl,
            serviceUrl: this.serverUrl,
            ...res,
          },
          isWayForPayEnabled: true,
        });
      })
      .catch((e) => {
        this.setState({ isLoading: false, isWayForPayEnabled: false });
        (console.error || console.log).call(console, e.stack || e);
      });
  }

  getWayForPayFormParameters(wayForPayId, sum, productName) {
    const request = {
      orderReference: wayForPayId,
      amount: sum,
      productName: productName,
    };

    return this.api
      .post('/wayforpay/sign', JSON.stringify(request), {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((r) => {
        return r.data;
      })
      .catch((error) => {
        let message = '';
        if (error.response) {
          message = `${error.response.status} ${
            error.response.statusText
          }\n${JSON.stringify(error.response.data)}`;
          // Request made and server responded
          console.log(error.response);
        } else if (error.request) {
          message = 'no response';
          console.log(error.request);
        } else {
          message = error.message;
          console.log('Error', error.message);
        }
        throw new Error(message);
      });
  }

  updateLiqpayFormParameters(orderId, sum, redirectUrl) {
    this.setState({ isLoading: true, buttonData: '', buttonSignature: '' });
    this.getLiqpayFormParameters(orderId, sum, redirectUrl)
      .then((res) => {
        console.log('received liqpay form parameters', res.data);
        this.setState({
          isLoading: false,
          buttonData: res.data,
          buttonSignature: res.signature,
        });
      })
      .catch((e) => {
        this.setState({ isLoading: false });
        (console.error || console.log).call(console, e.stack || e);
      });
  }

  getLiqpayFormParameters(orderId, sum, redirectUrl) {
    const request = {
      orderId: orderId,
      sum: sum,
      redirectUrl: redirectUrl,
    };

    return this.api
      .post('/liqpay', JSON.stringify(request), {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((r) => {
        return r.data;
      })
      .catch((error) => {
        let message = '';
        if (error.response) {
          message = `${error.response.status} ${
            error.response.statusText
          }\n${JSON.stringify(error.response.data)}`;
          // Request made and server responded
          console.log(error.response);
        } else if (error.request) {
          message = 'no response';
          console.log(error.request);
        } else {
          message = error.message;
          console.log('Error', error.message);
        }
        throw new Error(message);
      });
  }

  onPomocodeChanged = (e) => {
    this.setState({ promocode: e.target.value });
  };

  onPomocodeApplied = (e) => {
    e.preventDefault();

    const { t } = this.props;

    superagent
      .get(`/api/Price/${this.state.promocode}/${this.state.basePrice}`)
      .end((error, result) => {
        if (error) {
          console.log(error);
          alert(
            t(
              'Возникла ошибка при оформлении заказа.\r\nПожалуйста, свяжитесь с нами по телефону и мы оформим заказ вручную.\r\n'
            ) + error
          );
        } else {
          let isCorrect = false;
          try {
            const newPrice = parseInt(result.text);
            if (!isNaN(newPrice) && this.state.basePrice !== newPrice) {
              isCorrect = true;
              this.setState({
                priceWithoutShipping: newPrice,
                isPromocodeFailed: false,
                succeededPromocode: this.state.promocode,
                price: this.getPrice(newPrice, this.state.shippingCost),
              });
            }
          } catch (e) {
            (console.error || console.log).call(console, e.stack || e);
          }

          if (!isCorrect) {
            this.setState({
              isPromocodeFailed: true,
              succeededPromocode: '',
              priceWithoutShipping: this.state.basePrice,
              price: this.getPrice(
                this.state.basePrice,
                this.state.shippingCost
              ),
            });
          }
        }
      });
  };

  randomIntFromInterval = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
  };

  onSubmit = (e, callback) => {
    this.setState({
      isSubmitting: true,
    });

    this.product.price = this.state.price;
    this.product.basePrice = this.state.basePrice;
    this.product.promocode = this.state.promocode;
    this.product.shippingCost = this.state.shippingCost;
    const { productType } = this.product;
    const order = {
      id: this.orderId,
      product: this.product,
      shipping: e,
      canShipFromFactory: this.canShipFromFactory,
    };

    this.setState({
      wayForPay: {
        ...this.state.wayForPay,
        clientEmail: order.shipping?.email,
        clientPhone: order.shipping?.phone,
      },
    });

    try {
      const referral = Cookies.get('referral');
      order.shipping.referral = referral;
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }

    try {
      const host = window.location.hostname;

      function endsWith(str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
      }

      if (host.indexOf('localhost') !== 0) {
        if (
          !order ||
          !order.shipping ||
          !endsWith(order.shipping.email, '@test.com')
        ) {
          window.gtag('event', 'order', {
            send_to: this.gTagId,
            event_category: 'main',
            value: this.product.price,
            currency: 'UAH',
          });

          window.fbq('trackSingle', this.pixelId, 'Purchase', {
            value: this.product.price,
            currency: 'UAH',
          });
        }
      }
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }

    superagent
      .post(`/api/SkyOrder/create`)
      .send(order)
      .end((error, result) => {
        let isCorrect = false;
        this.setState({
          isSubmitting: false,
        });
        callback();

        if (!error) {
          try {
            const receivedOrderId = parseInt(result.text);
            if (receivedOrderId === order.id) {
              isCorrect = true;

              if (order?.shipping?.paymentType === 'liqpay') {
                this._liqpayForm.current.submit();
              } else if (order?.shipping?.paymentType === 'wayforpay') {
                this._wayForPayForm.current.submit();
              } else {
                this.props.history.push({
                  pathname: `/completed/${order.id}`,
                  //state: { orderId: order.id },
                });
              }
            } else {
              error = 'Received incorrect order id';
            }
          } catch (e) {
            error = e;
            (console.error || console.log).call(console, e.stack || e);
          }
        }

        if (!isCorrect) {
          alert(
            `Возникла ошибка при оформлении заказа.\r\nПожалуйста, свяжитесь с нами по телефону и мы оформим заказ вручную.\r\n${error}`
          );
        }
      });
  };

  fixMapLanguage = (language, text1, text2) => {
    if (!text1) return language;
    const ukChars = ['є', 'і', 'ї'];
    const ruChars = ['ё', 'ъ', 'ы', 'э'];

    if (language === 'uk' && this.containsAny(text1, ruChars)) {
      return 'ru';
    } else if (language === 'ru' && this.containsAny(text1, ukChars)) {
      return 'uk';
    }
    const cyrrilicRegex = /[а-яА-ЯЁёІіЇїЄє]/;
    if (!cyrrilicRegex.test(text1)) {
      if (!text2 || !cyrrilicRegex.test(text2)) {
        return 'en';
      }
    }

    return language;
  };

  areTextsInSameLanguage = (text1, text2) => {
    const ukChars = ['є', 'і', 'ї'];
    const ruChars = ['ё', 'ъ', 'ы', 'э'];
    const cyrrilicRegex = /[а-яА-ЯЁёІіЇїЄє]/;

    if (this.containsAny(text1, ruChars)) {
      if (
        this.containsAny(text2, ukChars) ||
        (text2 && !cyrrilicRegex.test(text2))
      ) {
        return false;
      }
    } else if (this.containsAny(text1, ukChars)) {
      if (
        this.containsAny(text2, ruChars) ||
        (text2 && !cyrrilicRegex.test(text2))
      ) {
        return false;
      }
    } else if (text1 && !cyrrilicRegex.test(text1)) {
      if (text2 && cyrrilicRegex.test(text2)) {
        return false;
      }
    }

    return true;
  };

  containsAny = (str, substrings) => {
    if (!str) {
      return null;
    }
    for (let i = 0; i != substrings.length; i++) {
      const substring = substrings[i];
      if (str.indexOf(substring) != -1) {
        return substring;
      }
    }
    return null;
  };

  onShippingCostChanged = (value) => {
    this.setState({
      shippingCost: value,
      price: this.getPrice(this.state.priceWithoutShipping, value),
    });
  };

  renderWayForPayProduct = (props) => {
    var productName = null;
    var productCount = null;
    var productPrice = null;
    if (props.productName) {
      productName = props.productName.map((name, index) => {
        return (
          <input
            name="productName[]"
            key={`productName${index}`}
            value={name}
            readOnly
          />
        );
      });
    }
    if (props.productCount) {
      productCount = props.productCount.map((count, index) => {
        return (
          <input
            name="productCount[]"
            key={`productCount${index}`}
            value={count}
            readOnly
          />
        );
      });
    }
    if (props.productPrice) {
      productPrice = props.productPrice.map((price, index) => {
        return (
          <input
            name="productPrice[]"
            key={`productPrice${index}`}
            value={price}
            readOnly
          />
        );
      });
    }
    return (
      <>
        {productName}
        {productCount}
        {productPrice}
      </>
    );
  };

  render() {
    console.log('Rendering Cart');

    const { t } = this.props;

    const {
      city,
      description: { material, size, hanger, style },
    } = this.product;
    return (
      <div className="d-flex flex-column">
        <Header></Header>

        <div className="container g-pt-40 g-pb-40">
          <div className="text-center">
            <div className="mb-4">
              <h1 className="h2">{t('Оформлення замовлення')}</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8 order-2 order-md-1">
              <CartFormWithValidation
                onSubmit={this.onSubmit}
                canShipFromFactory={this.canShipFromFactory}
                isFreeShippingTurnedOn={this.isFreeShippingTurnedOn}
                needPrepayment={this.needPrepayment}
                isWayForPayEnabled={this.state.isWayForPayEnabled}
                onShippingCostChanged={this.onShippingCostChanged}
                shippingDates={this.state.shippingDates}
                canPayByCash={this.canPayByCash}
              ></CartFormWithValidation>
            </div>
            <div className="col-md-4 order-1 order-md-2">
              <div className="g-bg-gray-light-v5 g-pa-20 g-pb-20 g-mb-20">
                <h4 className="h6 text-uppercase mb-3">
                  {t('Інформація про замовлення')}
                </h4>

                <div
                  id="accordion-03"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div
                    id="accordion-03-heading-03"
                    className="g-brd-y g-brd-gray-light-v2 py-3"
                    role="tab"
                  >
                    <h5 className="g-font-weight-400 g-font-size-default mb-0">
                      <a
                        className="g-color-gray-dark-v4 g-text-underline--none--hover"
                        href="#accordion-03-body-03"
                        data-toggle="collapse"
                        data-parent="#accordion-03"
                        aria-expanded="false"
                        aria-controls="accordion-03-body-03"
                      >
                        {t('1 товар(ів) в замовленні')}
                        <span className="ml-3 fa fa-angle-down"></span>
                      </a>
                    </h5>
                  </div>
                  <div
                    id="accordion-03-body-03"
                    className="collapse"
                    role="tabpanel"
                    aria-labelledby="accordion-03-heading-03"
                  >
                    <div className="g-py-15">
                      <ul className="list-unstyled g-ma-0 g-pa-0">
                        <li className="d-flex justify-content-start g-brd-gray-light-v3">
                          <div className="d-block">
                            <h4 className="h6 g-color-black">
                              {t('Плакат')} {city}
                            </h4>
                            <ul className="list-unstyled g-color-gray-dark-v4 g-font-size-12 g-line-height-1_4 mb-1">
                              <li>
                                {t('Матеріал')}: {material}{' '}
                              </li>
                              <li>
                                {t('Розмір')}: {size}
                              </li>
                              <li>
                                {t('Рамка/Тримач')}: {hanger}
                              </li>
                              <li>
                                {t('Стиль')}: {style}{' '}
                              </li>
                            </ul>
                            <span className="d-block g-color-black g-font-weight-400">
                              {this.state.price} {t('грн')}
                            </span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div
                  id="accordion-promo"
                  role="tablist"
                  aria-multiselectable="true"
                  className="g-mt-minus-1"
                >
                  <div
                    id="accordion-promo-heading"
                    className="g-brd-y g-brd-gray-light-v2 py-3"
                    role="tab"
                  >
                    <h5 className="g-font-weight-400 g-font-size-default mb-0">
                      <a
                        className="g-color-gray-dark-v4 g-text-underline--none--hover"
                        href="#accordion-promo-body"
                        data-toggle="collapse"
                        data-parent="#accordion-promo"
                        aria-expanded="false"
                        aria-controls="accordion-promo-body"
                      >
                        {t('Промокод')}
                        <span className="ml-3 fa fa-angle-down"></span>
                      </a>
                    </h5>
                  </div>

                  <div
                    id="accordion-promo-body"
                    className="collapse"
                    role="tabpanel"
                    aria-labelledby="accordion-promo-heading"
                  >
                    <div className="row g-mt-15">
                      <div className="col-6">
                        <div className="form-group">
                          <input
                            className="form-control form-control-md rounded-0"
                            placeholder={t('Промокод')}
                            value={this.state.promocode}
                            onChange={this.onPomocodeChanged}
                          />
                        </div>
                      </div>
                      <div className="col-6">
                        <button
                          className="btn btn-block u-btn-primary g-font-size-13 text-uppercase g-py-10 mb-4"
                          type="button"
                          onClick={this.onPomocodeApplied}
                        >
                          {t('Застосувати')}
                        </button>
                      </div>
                    </div>
                    {this.state.isPromocodeFailed ? (
                      <div className="d-flex justify-content-between g-mt-0">
                        <span className="g-color-black">
                          {t(
                            'Цей промокод недійсний, або не застосовується для даного товару'
                          )}
                        </span>
                      </div>
                    ) : null}

                    {this.state.succeededPromocode ? (
                      <div className="d-flex justify-content-between g-mt-0">
                        <span className="g-color-black">
                          {t('Промокод')} {this.state.succeededPromocode}{' '}
                          {t('застосований')}
                        </span>
                      </div>
                    ) : null}
                  </div>
                </div>
                <a
                  className="d-inline-block g-color-text g-color-primary--hover g-text-underline--none--hover g-mt-10"
                  href="/return.html"
                  target="_blank"
                >
                  <i className="mr-2 fa fa-info-circle"></i>{' '}
                  {t('Обмін та повернення')}
                </a>
                <div className="d-flex justify-content-between g-mt-10">
                  <span className="g-color-black">
                    {t('Вартість без доставки')}
                  </span>
                  <span>
                    {this.state.succeededPromocode ? (
                      <del>
                        <span className="g-color-black g-font-weight-300">
                          {this.state.basePrice}{' '}
                        </span>
                      </del>
                    ) : null}

                    <span className="g-color-black g-font-weight-300">
                      {this.state.priceWithoutShipping} {t('грн')}
                    </span>
                  </span>
                </div>
                {this.state.shippingCost != null ? (
                  <div>
                    <div className="d-flex justify-content-between g-mt-10">
                      <span className="g-color-black">{t('Доставка')}</span>
                      <span>
                        <span className="g-color-black g-font-weight-300">
                          {this.state.shippingCost === 0 ? (
                            <>{t('безкоштовно')}</>
                          ) : (
                            <>
                              {this.state.shippingCost} {t('грн')}
                            </>
                          )}
                        </span>
                      </span>
                    </div>
                    <div className="d-flex justify-content-between g-mt-10 g-brd-y g-brd-gray-light-v2 py-3">
                      <span className="g-color-black">{t('До сплати')}</span>
                      <span>
                        <span className="g-color-black g-font-weight-300">
                          {this.state.price} {t('грн')}
                        </span>
                      </span>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <form
          method="POST"
          action="https://www.liqpay.ua/api/3/checkout"
          acceptCharset="utf-8"
          className="d-none"
          ref={this._liqpayForm}
        >
          <input type="hidden" name="data" value={this.state.buttonData} />
          <input
            type="hidden"
            name="signature"
            value={this.state.buttonSignature}
          />
          <input
            type="image"
            src="//static.liqpay.ua/buttons/p1ru.radius.png"
          />
        </form>
        <form
          method="post"
          action="https://secure.wayforpay.com/pay"
          acceptCharset="utf-8"
          className="d-none"
          ref={this._wayForPayForm}
        >
          <input
            name="merchantAccount"
            value={this.state.wayForPay.merchantAccount}
            readOnly
          />
          <input
            name="merchantDomainName"
            value={this.state.wayForPay.merchantDomainName}
            readOnly
          />
          <input
            name="merchantSignature"
            value={this.state.wayForPay.merchantSignature}
            readOnly
          />

          <input
            name="orderReference"
            value={this.state.wayForPay.orderReference}
            readOnly
          />
          <input
            name="orderDate"
            value={this.state.wayForPay.orderDate}
            readOnly
          />
          <input name="amount" value={this.state.wayForPay.amount} readOnly />
          <input
            name="currency"
            value={this.state.wayForPay.currency}
            readOnly
          />
          {this.renderWayForPayProduct(this.state.wayForPay)}
          <input
            name="returnUrl"
            value={this.state.wayForPay.returnUrl}
            readOnly
          />
          <input
            name="serviceUrl"
            value={this.state.wayForPay.serviceUrl}
            readOnly
          />
          <input
            name="clientEmail"
            value={this.state.wayForPay.clientEmail}
            readOnly
          />
          <input
            name="clientPhone"
            value={this.state.wayForPay.clientPhone}
            readOnly
          />
        </form>

        {this.state.isSubmitting ? (
          <div className="overlay h-100 w-100 text-center">
            <div className="lds-dual-ring"></div>
          </div>
        ) : null}

        <Footer></Footer>
      </div>
    );
  }
}

export default withTranslation()(Cart);
